import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { budgetsActions } from "../actions";
import api from "../services/budgets.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { budgetPagination } from "../selectors/budgets.selector";
import { getProjectBudgetSummary } from "../actions/projects.actions";
import { getPortFolioBudgetSummary } from "../actions/portfolio.actions";
import { getProgramBudgetSummary } from "../actions/programs.actions";

function* sortBudgets(state) {
  try {
    yield put(budgetsActions.sortBudgetRequestAttempt.pending);
    const budgets = yield call(api.sortBudgetsRequest, state.payload);
    const pagination = JSON.parse(budgets.headers["x-pagination"]);
    const data = {
      data: budgets.data,
      pagination: pagination,
    };
    yield put(budgetsActions.sortBudgetRequestAttempt.success(data));
  } catch (error) {
    yield put(budgetsActions.sortBudgetRequestAttempt.error(error.message));
  }
}

function* getBudgets(state) {
  try {
    yield put(budgetsActions.getBudgetsAttempt.pending);
    const budgets = yield call(api.getBudgetsRequest, state.payload);
    if (state.payload.parent === "Project") {
      const data = {
        data: budgets.data,
        pagination: null,
      };
      yield put(budgetsActions.getBudgetsAttempt.success(data));
    } else {
      const pagination = JSON.parse(budgets.headers["x-pagination"]);
      const data = {
        data: budgets.data,
        pagination: pagination,
      };
      yield put(budgetsActions.getBudgetsAttempt.success(data));
    }
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(budgetsActions.getBudgetsAttempt.error(""));
    } else {
      yield put(budgetsActions.getBudgetsAttempt.error(error.message));
    }
  }
}

function* createBudget(state) {
  try {
    yield put(budgetsActions.createBudgetAttempt.pending);
    yield call(api.createBudgetRequest, state.payload);
    // const paginat = yield select(budgetPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    // const payload = {id: state.payload.payload.ProjectId, page: paginat.CurrentPage, size: paginat.PageSize}
    const budgets = yield call(api.getBudgetsRequest, payload);
    const pagination = JSON.parse(budgets.headers["x-pagination"]);
    const data = {
      data: budgets.data,
      pagination: pagination,
    };
    yield put(budgetsActions.createBudgetAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Budget saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Netwrok Error!"
    ) {
      yield put(budgetsActions.createBudgetAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(budgetsActions.createBudgetAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(budgetsActions.createBudgetAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateBudget(state) {
  try {
    yield put(budgetsActions.updateBudgetAttempt.pending);
    yield call(api.updateBudgetRequest, state.payload);
    if (state.payload.parent == "Project") {
      yield put(getProjectBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramBudgetSummary({ id: state.payload.parentID }));
    }
    ///const paginat = yield select(budgetPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
    };
    // const payload = {id: projectID, page: paginat.CurrentPage, size: paginat.PageSize}
    const budgets = yield call(api.getBudgetsRequest, payload);
    const data = {
      data: budgets.data,
      pagination: {},
    };
    yield put(budgetsActions.updateBudgetAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Budget updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(budgetsActions.updateBudgetAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(budgetsActions.updateBudgetAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(budgetsActions.updateBudgetAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteBudget(state) {
  try {
    yield put(budgetsActions.deleteBudgetAttempt.pending);
    yield call(api.deleteBudgetRequest, state.payload);
    const paginat = yield select(budgetPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const budgets = yield call(api.getBudgetsRequest, payload);
    const pagination = JSON.parse(budgets.headers["x-pagination"]);
    const data = {
      data: budgets.data,
      pagination: pagination,
    };
    yield put(budgetsActions.deleteBudgetAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Budget deleted",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(budgetsActions.deleteBudgetAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(budgetsActions.deleteBudgetAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(budgetsActions.deleteBudgetAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateBudgetFlag(state) {
  try {
    yield put(budgetsActions.updateBudgetFlagAttempt.pending);
    yield call(api.updateBudgetFlagRequest, state.payload);
    yield put(budgetsActions.updateBudgetFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Budget flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(budgetsActions.updateBudgetFlagAttempt.error(error.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SORT_BUDGETS_CALL, sortBudgets),
    takeEvery(ACTIONS.BUDGETS_CALL, getBudgets),
    takeEvery(ACTIONS.CREATE_BUDGET_CALL, createBudget),
    takeEvery(ACTIONS.UPDATE_BUDGET_CALL, updateBudget),
    takeEvery(ACTIONS.DELETE_BUDGET_CALL, deleteBudget),
    takeEvery(ACTIONS.BUDGET_FLAG_CALL, updateBudgetFlag),
  ]);
}
